module.exports = "//img4.xes1v1.com/resources/fe-1v1-pclp/img/logo2.fa0481b8.png";